import React from 'react'
import { Transforms } from 'slate'
import { withHistory } from 'slate-history'
import { IEditorPlugin } from '../EditorService'
import { ParagraphElementDef, ParagraphLeaf } from '../elements/ParagraphElement'
import { TaskListCommands, TaskListElementDef, TaskListItemElementDef } from '../elements/TaskListElement'
import { BulletListElementDef, ListItemElementDef, NumberedListElementDef } from '../elements/ListElements'
import { ImageElementDef } from '../elements/ImageElement'
import { MentionElementDef } from '../elements/MentionElement'
import { COMMON_ELEMENTS, ContentCommands, ListTypes } from '../commands'
import { LinkElementDef } from 'editor/elements'

export const ContentPlugin: IEditorPlugin = {
  setup(e) {
    const { normalizeNode } = e

    e.normalizeNode = ([node, path]) => {
      // LOGGER.debug('NORMALIZING', node, path)
      if (path.length === 0) {
        if (e.children.length < 1) {
          Transforms.insertNodes(e, { type: 'paragraph', children: [{ text: '' }] }, { at: path.concat(1) })
        }
      }
      return normalizeNode([node, path])
    }

    e = withHistory(e)
    return e
  },
  elements: {
    'image': ImageElementDef,
    'mention': MentionElementDef,
    'paragraph': ParagraphElementDef,
    'tasklist-item': TaskListItemElementDef,
    'tasklist': TaskListElementDef,
    'link': LinkElementDef,
    'list-item': ListItemElementDef,
    'list-bulleted': BulletListElementDef,
    'list-numbered': NumberedListElementDef,
  },
  leaves: {
    'default': props => <ParagraphLeaf {...props} />,
  },
  commands: [
    { title: 'Insert Image', handler: (e, s) => ContentCommands.insertImage(s) },
    { title: 'Toggle Bold', shortcut: 'meta+b', handler: (e) => ContentCommands.toggleBold(e), elements: COMMON_ELEMENTS },
    { title: 'Toggle Italic', shortcut: 'meta+i', handler: (e) => ContentCommands.toggleItalic(e), elements: COMMON_ELEMENTS },
    { title: 'Toggle Underline', shortcut: 'meta+u', handler: (e) => ContentCommands.toggleUnderline(e), elements: COMMON_ELEMENTS },
    { title: 'Toggle Link', shortcut: 'meta+shift+l', handler: (e, s) => ContentCommands.toggleLink(s) },
    { title: 'Insert Task List', handler: (e, s) => TaskListCommands.insertTaskList(s) },
    { title: 'Toggle List', shortcut: 'meta+shift+-', handler: (e, s) => ContentCommands.toggleList(s, ListTypes.bulleted), elements: COMMON_ELEMENTS },
    { title: 'Toggle Ordered List', shortcut: 'meta+shift+1', handler: (e, s) => ContentCommands.toggleList(s, ListTypes.numbered), elements: COMMON_ELEMENTS },
  ],
}
